export default "__VITE_ASSET__BEcZa95q__"